'use client';

import React from 'react';
import { SpinnerContainer, SvgContainer, StyledSvg, StatusMessage } from './elements';
import { useComponentDeprecation } from '../../util';

/** @deprecated */

/** @deprecated */
export const AsurionDoodleSpinner = ({
  title = '',
  text
}) => {
  useComponentDeprecation({
    name: 'AsurionDoodleSpinner',
    version: 'v5',
    alternative: 'PageLoader'
  });
  return /*#__PURE__*/React.createElement(SpinnerContainer, null, /*#__PURE__*/React.createElement(SvgContainer, null, /*#__PURE__*/React.createElement(StyledSvg, {
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 100 100",
    "aria-describedby": "loader-title",
    role: "img"
  }, /*#__PURE__*/React.createElement("title", {
    id: "loader-title"
  }, title), /*#__PURE__*/React.createElement("g", {
    id: "eshqr40zbaj2",
    transform: "translate(47.603,51.052) scale(0.85,0.85) translate(-275.839,-163.84)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eshqr40zbaj3",
    opacity: "1",
    transform: "translate(278.873,163.84) translate(-39.103,-52.638)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M6.605,70.547C-33.541,21.349,63.656,-17.331,80.286,46.379C90.332,100.575,17.004,70.793,42.373,46.379C74.39,20.333,63.805,139.242,6.605,70.547",
    stroke: "#000000",
    strokeOpacity: "1",
    strokeWidth: "4",
    strokeMiterlimit: "1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "170 170",
    strokeDashoffset: "800",
    style: {
      animation: '2s linear infinite both a0_do'
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "eshqr40zbaj4_to",
    opacity: "1",
    transform: "translate(240.362,143.867) translate(7.163,-9.199)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eshqr40zbaj4_tr",
    opacity: "1",
    transform: "translate(0.252,-0.155) rotate(200.603) translate(-1.809,7.071)",
    style: {
      animation: '2s linear infinite both eshqr40zbaj4_tr_t'
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "eshqr40zbaj4",
    opacity: "1",
    transform: "translate(5.345,-14.475) translate(-240.549,-108.197)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M228.968,100.867C228.968,100.867,236.681,115.528,236.681,115.528C236.681,115.528,252.13,107.4,252.13,107.4",
    stroke: "#000000",
    strokeOpacity: "1",
    strokeWidth: "4",
    strokeMiterlimit: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))), !!text && /*#__PURE__*/React.createElement(StatusMessage, null, text));
};